// @core/api/endpoints/task/update_task_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskPolicyResponse,
  UpdateTaskPolicyRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update task policy
 * Updates an existing task policy. Changes apply to new tasks; existing tasks keep their current settings.
 */
export async function UpdateTaskPolicy(
  policy_id: string,
  data: UpdateTaskPolicyRequest,
  options?: RequestOptions
): Promise<TaskPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<TaskPolicyResponse>(requestPath, data, requestOptions);
}
